export default {
  namespaced: true,
  state: {
    readOnlyMode: false,
    taxons: {},
    existingBrands: [],
    product: {
      ageGroup: null,
      ageRestriction: null,
      boostSort: null,
      brand: null,
      description: null,
      doesSubsidize: false,
      gender: null,
      id: null,
      images: [],
      ingredients: {},
      name: null,
      nutrienContents: {},
      preorderDays: null,
      serviceIds: [],
      shippingMethodIds: [],
      subsidyAmount: 0.0,
      taxCategoryId: null,
      taxonIds: [],
      vendorDoesSubsidize: false,
      active: null,
      variants: [
        {
          id: null,
          price: null,
          priceSale: null,
          baseUnit: null,
          baseAmount: null,
          baseAmountProduct: null,
          countOnHand: null,
          tradeId: null,
          mpn: null,
          uniqueId: null,
          properties: [],
        },
      ],
    },
  },
  getters: {
    images: state => state.product.images,
    productTaxons: state => state.product.taxons,
    taxonsByParent: state => state.taxons,
    taxonsFlat: state => Object.values(state.taxons).flat(),
    taxonsById: state =>
      Object.values(state.taxons)
        .flat()
        .reduce((acc, taxon) => {
          acc[taxon.id] = taxon;
          return acc;
        }, {}),
    existingBrands: state => state.existingBrands,
    brand: state => state.product.brand,
    description: state => state.product.description,
    name: state => state.product.name,
    serviceIds: state => state.product.serviceIds,
    taxonIds: state => state.product.taxonIds,
    ingredients: state => state.product.ingredients,
    nutrienContents: state => state.product.nutrienContents,
    ageRestriction: state => state.product.ageRestriction,
    shippingMethodIds: state => state.product.shippingMethodIds,
    variants: state => state.product.variants,
    readOnlyMode: state => state.readOnlyMode,
    boostSort: state => state.product.boostSort,
    taxCategoryId: state => state.product.taxCategoryId,
    preorderDays: state => state.product.preorderDays,
    doesSubsidize: state => state.product.doesSubsidize,
    subsidyAmount: state => state.product.subsidyAmount,
    vendorDoesSubsidize: state => state.product.vendorDoesSubsidize,
    gender: state => state.product.gender,
    ageGroup: state => state.product.ageGroup,
    active: state => state.product.active,
    variantImages: state => index => state.product.variants[index]?.images,
  },
  actions: {
    addProductImage: ({ commit, state }, { file, preview }) => {
      const images = getUpdatedImages(state.product.images, { file, preview });
      const positionedImages = recalculatePosition(images);

      commit("setProductImages", positionedImages);
    },
    addVariantImage: ({ commit, state }, { file, preview, index }) => {
      const images = getUpdatedImages(state.product.variants[index].images, { file, preview });
      const positionedImages = recalculatePosition(images);

      commit("setVariantImages", { images: positionedImages, index });
    },
    setAllTaxons: ({ commit }, taxons) => commit("setAllTaxons", taxons),
    setExistingBrands: (context, brands) => {
      context.commit("setExistingBrands", brands);
    },
    setProduct: (context, product) => {
      context.commit("setProduct", product);
    },
    setProductImages: ({ commit }, images) =>
      commit(
        "setProductImages",
        images.map((element, idx) => ({ ...element, position: idx }))
      ),
    setVariantImages: ({ commit }, { images, index }) =>
      commit("setVariantImages", {
        images: images.map((element, idx) => ({ ...element, position: idx })),
        index,
      }),
    setVariantDirty: ({ commit }, index) => commit("setVariantDirty", index),
    setProductData: ({ commit }, productData) => commit("setProductData", productData),
    setVariant: ({ commit }, variant) => commit("setVariant", variant),
    setReadOnlyMode: ({ commit }, readOnlyMode) => commit("setReadOnlyMode", readOnlyMode),
  },
  mutations: {
    setAllTaxons: (state, taxons) => (state.taxons = taxons),
    setExistingBrands: (state, brands) => {
      state.existingBrands = brands;
    },
    setProduct: (state, product) => {
      state.product = product;
    },
    setProductImages: (state, images) => {
      state.product = {
        ...state.product,
        images: images,
      };
    },
    setVariantImages: (state, { images, index }) => {
      const product = state.product;
      product.variants[index].images = images;
      state.product = { ...product };
    },
    setProductData: (state, productData) => (state.product = { ...state.product, ...productData }),
    setVariant: (state, variant) => {
      const index = variant.index;
      delete variant.index;

      const variants = state.product.variants;
      variants[index] = variant;
      state.product.variants = [...variants];
    },
    setReadOnlyMode: (state, readOnlyMode) => (state.readOnlyMode = readOnlyMode),
    setVariantDirty: (state, index) => {
      const product = state.product;
      product.variants[index].dirtyData = true;
      state.product = { ...product };
    },
  },
};

const recalculatePosition = images => {
  return [...images].map((element, idx) => ({
    ...element,
    position: idx,
  }));
};

const getUpdatedImages = (storeImages, { file, preview }) => {
  let image, images;
  const existingIndex = storeImages.findIndex(image => image.id == file.id);
  const alreadyExists = existingIndex != -1;
  const isThumbnail = !!preview;

  if (alreadyExists) {
    image = storeImages[existingIndex];
  } else {
    image = { persisted: false, id: file.id };
  }

  if (isThumbnail) {
    image.url = preview;
  } else {
    image.attachment = {
      id: file.meta["key"].match(/^cache\/(.+)/)[1],
      storage: "cache",
      metadata: {
        size: file.size,
        filename: file.name,
        mime_type: file.type,
      },
    };
  }

  if (alreadyExists) {
    storeImages[existingIndex] = image;
    images = storeImages;
  } else {
    images = [...storeImages, image];
  }

  return images;
};
